import { render } from "./wrapper.vue?vue&type=template&id=534712c3"
import script from "./wrapper.vue?vue&type=script&lang=ts"
export * from "./wrapper.vue?vue&type=script&lang=ts"
script.render = render

export default script